module.exports = new __parcel__URL__("soleil-nuage-1-pluie-1.60181a3f.svg").toString();